import { CardData } from "../CardData";
import { getAllCardData } from "../db";
import { PromisedType } from "./PromisedType";

declare global {
  interface Window {
    __ALL_CARD_DATA__: PromisedType<ReturnType<typeof getAllCardData>> | null;
    snapSaveState: () => { [key: string]: any };
  }
}

export async function deserializeOrFetchAllCardData(): ReturnType<
  typeof getAllCardData
> {
  if (window.__ALL_CARD_DATA__) {
    console.log("Deserializing card data from SSR");
    const result = Promise.resolve({
      cardIDsByEssay: window.__ALL_CARD_DATA__.cardIDsByEssay,
      cardDataByCardID: new Map(
        Object.entries(window.__ALL_CARD_DATA__.cardDataByCardID),
      ),
      essayVersions: window.__ALL_CARD_DATA__.essayVersions,
    });
    delete window.__ALL_CARD_DATA__;
    return result;
  } else {
    return getAllCardData();
  }
}

export function saveAllCardData(
  allCardData: PromisedType<ReturnType<typeof getAllCardData>>,
) {
  if (navigator.userAgent === "ReactSnap") {
    const { cardDataByCardID, cardIDsByEssay, essayVersions } = allCardData;

    // Maps aren't JSON-serializable.
    const serializableCardDataByCardID: { [key: string]: CardData } = {};
    cardDataByCardID.forEach(
      (cardData, cardID) => (serializableCardDataByCardID[cardID] = cardData),
    );

    const oldSnapSaveState =
      window.snapSaveState ||
      (() => {
        return {};
      });

    window.snapSaveState = () => {
      console.log("Saving data.");
      return {
        ...oldSnapSaveState(),
        __ALL_CARD_DATA__: {
          cardIDsByEssay,
          essayVersions,
          cardDataByCardID: serializableCardDataByCardID,
        },
      };
    };
  }
}
